module.exports = __webpack_public_path__ + "img/cate3.a8f811ca.jpg";